import { VueRegistration } from "@abaco/web-common/src/app";
const STANDARD_PORTAL = "STANDARD_PORTAL";

const globals: VueRegistration = {
    // CONTAINERS
    StepperContainer: () => import("./components/StepperContainer.vue"),
    SingleTileContainer: () => import("./components/SingleTileContainer.vue"),
    DetailContainer: () => import("./components/DetailContainer.vue"),
    DirectDetailContainer: () => import("./components/DirectDetailContainer.vue"),
    ActivitiesAddActivityMode: () => import("./components/ActivitiesAddActivityContainer.vue"),

    // PUBLIC TILES
    PlannedActivitiesTile: () => import("./components/tiles/PlannedActivitiesTile.vue"),
    CalendarActivityTile: () => import("./components/tiles/CalendarActivityTile.vue"),
    ActivityViolationsTile: () => import("./components/tiles/ActivityViolationsTile.vue"),
    WorkersActivitiesTile: () => import("./components/tiles/WorkersActivitiesTile.vue"),

    // PUBLIC CHARTS
    ActivitiesChartTile: {
        meta: {
            i18nDescrKey: "planned-vs-executed",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/charts/ActivitiesChartTile.vue")
    },
    ActivitiesProgressChartTile: {
        meta: {
            i18nDescrKey: "activities-progress",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "plot-group-selection-nav-bar-item"
            ],
            pinnable: true
        },
        component: () => import("./components/tiles/charts/ActivitiesProgressChartTile.vue")
    },
    IncomingActivitiesChartTile: {
        meta: {
            i18nDescrKey: "incoming-activities-1",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/charts/IncomingActivitiesChartTile.vue")
    },
    IrrigationActivitiesWidget: {
        meta: {
            i18nDescrKey: "irrigation-activities-widget",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: STANDARD_PORTAL
        },
        component: () => import("./components/tiles/charts/IrrigationActivitiesWidget.vue")
    },
    TracksListTile: {
        meta: {
            i18nDescrKey: "select-tracks",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: STANDARD_PORTAL
        },
        component: () => import("./components/tiles/TracksListTile.vue")
    },
    TracksMapTile: {
        meta: {
            i18nDescrKey: "track-map",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: STANDARD_PORTAL
        },
        component: () => import("./components/tiles/TracksMapTile.vue")
    },
    WorkerReportChartTile: {
        meta: {
            i18nDescrKey: "worker-report-widget",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item", "plot-group-selection-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/charts/WorkerReportChartTile.vue")
    },

    // PRIVATE TILES
    AddActivitySummaryTile: () => import("./components/tiles/private/AddActivitySummaryTile.vue"),
    EditActivitySummaryTile: () => import("./components/tiles/private/EditActivitySummaryTile.vue"),
    AddActivityStepperTile: () => import("./components/tiles/private/AddActivityStepperTile.vue"),
    EditActivityStepperTile: () => import("./components/tiles/private/EditActivityStepperTile.vue"),
    ActivityDetailTile: () => import("./components/tiles/private/ActivityDetailTile.vue"),
    AddActionFromActivityTile: () => import("./components/tiles/private/AddActionFromActivityTile.vue"),
    AddActionSummaryTile: () => import("./components/tiles/private/AddActionSummaryTile.vue"),
    ActionDetailTile: () => import("./components/tiles/private/ActionDetailTile.vue"),
    EditActionOnlyStepperTile: () => import("./components/tiles/private/EditActionOnlyStepperTile.vue"),
    EditActionOnlySummaryTile: () => import("./components/tiles/private/EditActionOnlySummaryTile.vue"),
    ActionDocumentListTile: () => import("./components/tiles/private/documents/ActionDocumentListTile.vue"),
    ActionDocumentIframe: () => import("./components/tiles/private/documents/ActionDocumentIframe.vue"),

    PhytochemicalSelectionModal: () => import("./components/tiles/private/PhytochemicalSelectionModal.vue"),
    UsersList: () => import("./components/private/UsersList.vue"),
    TrackStepper: () => import("./components/private/TrackStepper.vue"),
    FreeTrackStep: () => import("./components/steps/FreeTrackStep.vue"),
    FreeTrackDetailStep: () => import("./components/steps/FreeTrackDetailStep.vue"),
    FreeTrackContainer: () => import("./components/FreeTrackContainer.vue"),
    FreeTrackMapTile: () => import("./components/tiles/FreeTrackMapTile.vue")
};

export default globals;
